export const PATH_LOGIN = "/auth/signin";
export const PATH_REGISTER = "/register";
export const PATH_WINDOWS = "/windows";
export const PATH_RFQWINDOWS = "/rfqwindows";
export const PATH_RFQ = "/rfq";
export const PATH_WINDOWSCONFIG = "/windowsconfiguration";

export const PATH_PROJECT_DETAIL = "/dealer/projectdetail";
export const PATH_WINDOW_PROJECTS = "/dealer/projects";
export const PATH_SUBMIT_BID = "/dealer/bid";
export const PATH_HOME = "/";
export const PATH_PROFILE = "/profile";
export const PATH_VIEWER = "/viewer";
export const PATH_PAGE_NOT_FOUND = "*";
export const PATH_DEALER = "/dealerHome";

export const PATH_PROJECT = "/projects";
export const PATH_PROJECT_LIST = "/projectList/projectList";
export const PATH_PROJECT_LIST_DETAILS = "/projectList/projectListDetails";
export const PATH_PROJECT_CHOOSER = "/chooserView";
//Mobile Paths
export const PATH_MOB_PROJECTS = "/mobile/projects";
export const PATH_MOB_PROJECT_DETAIL = "/mobile/project-detail";
export const PATH_MOB_QRCODE = "/mobile/qrcode";
